import createConfig from './EnvConfig';
import defaultClientConfig from './lib/defaultClientConfig';
import { ClientConfig } from './types/ClientConfig';

defaultClientConfig.validate();
const config = createConfig<ClientConfig & Record<string, unknown>>({
    namespace: 'jucy.clientConfig',
    defaultConfig: defaultClientConfig.getProperties(),
});

export default config;
